import { Box, Button, Stack, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import String from '../components/String';
import Layout from '../components/Layout';
import SetupStep from '../components/SetupStep';
import { useLanguage } from '../contexts/language';
import { useQueryParams } from '../hooks/useQueryParams';
import LanguageSelector from '../components/LanguageSelector';

const ManualCodeInstructions = () => {
  const { content } = useLanguage();
  const queryParams = useQueryParams();
  const codeFromUrl = queryParams.get('agami-manual-code') ?? '';
  const decodedCodeFromUrl = decodeURIComponent(codeFromUrl);
  return (
    <Layout
      fullscreen
      framed
      top={
        <Box mt="8vh" textAlign="center">
          <Box position="absolute" top={0} right={0} textAlign="right">
            <LanguageSelector />
          </Box>
          <Logo />
        </Box>
      }
    >
      <SetupStep
        themeSwitcher
        title={content('manual_code_intro')}
        form={
          <>
            {/* Body */}
            <Stack mt={4} spacing={2} alignItems="center" aria-labelledby="manual-code-explanation">
              <Typography
                component="p"
                variant="body1"
                align="center"
                aria-label={content('aria_explanation')}
                id="manual-code-explanation"
              >
                <strong>
                  <String s="manual_code_heading" />
                </strong>
              </Typography>

              <Typography component="p" variant="body1" align="center">
                <String s="manual_code_explanation" />
              </Typography>

              {decodedCodeFromUrl && (
                <Box
                  mt={1}
                  px={2}
                  py={1}
                  borderRadius={8}
                  border="1px solid rgba(0,0,0,0.12)"
                  aria-live="polite"
                >
                  <Typography component="p" variant="caption" align="center">
                    <em>Code:</em> <strong>{decodedCodeFromUrl}</strong>
                  </Typography>
                </Box>
              )}

              {/* CTAs */}
              <Stack
                spacing={1.5}
                direction="column"
                alignItems="stretch"
                mt={2}
                sx={{ width: '100%', maxWidth: 420 }}
              >
                {/* Homepage (keep internal if your router handles it; otherwise absolute) */}
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  component={Link}
                  to="/"
                  aria-label={content('aria_button_homepage')}
                >
                  <String s="manual_code_cta_homepage" />
                </Button>
              </Stack>
            </Stack>

            {/* Footer */}
            <Box mt={4}>
              <Typography component="p" variant="caption" align="center" color="textSecondary">
                <String s="manual_code_footer" />{' '}
                <a href="https://agami.mezzoforte.design" target="_blank" rel="noreferrer">
                  agami.mezzoforte.design
                </a>
              </Typography>
            </Box>
          </>
        }
      />
    </Layout>
  );
};

export default ManualCodeInstructions;
